import betoniAttrDataClass from "src/data/betoni/betoniAttrDataClass";
import betoniRasitusluokkaClass from "./betoniRasitusluokkaClass";
import betoniAttrClass from "./betoniAttrClass";
import betoniLujuusClass from "./betoniLujuusClass";
import notkeusClass from "./betoniNotkeusClass";
import raeKokoClass from "./betoniRaeKokoClass";
import betoniLaatuClass from "./betoniLaatuClass";
import KayttoIkaClass from "./betoniKayttoIkaClass";
import { checkResponse, hashCode } from "src/components/js/statics1";
import { betoni_getString } from "./BetoniFunctions";
import { keikkaBetoni_cacheName, cache_read, cache_write } from "src/components/js/CacheFunctions";

export default class betoniClass {
  constructor() {
    this.keikkaId = 0;
    this.orderNo = 0;
    this.keikkaBetoniId = 0;
    this.m3 = null;
    this.isNopea = false;
    this.laatu = new betoniLaatuClass();
    this.raeKoko = new raeKokoClass();
    this.lujuus = new betoniLujuusClass();
    this.notkeus = new notkeusClass();
    this.rasitus = new betoniRasitusluokkaClass();
    this.attr = new betoniAttrClass();
    this.kayttoIka = new KayttoIkaClass();
    this.betoniComment = null;
    this.originalHash = "";
    // this.hinta = new betoniHintaClass();
    this.eur = null;
    this.betoniVahvistettu = null;
    this.toimitus = {};
    this.hinta_muistiinpanot = "";
    this.hinta_value = 0;
  }

  loadApiData = async (keikkaBetoniId, token, doNotLoadBetoniAttr = false) => {
    try {
      const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/get/" + keikkaBetoniId;
      const c = cache_read(keikkaBetoni_cacheName, fullUrl);
      if (c) {
        for (let i = 0; i < c.length; i++) {
          await this.processApiData(c[i], doNotLoadBetoniAttr, token);
        }
        return this;
      }
      const response = await fetch(fullUrl, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "betoniClass.js:loadApiData");
      if (!cResponse.success) return false;
      const result = cResponse.data;
      cache_write(keikkaBetoni_cacheName, fullUrl, result, 0);
      for (let i = 0; i < result.length; i++) {
        await this.processApiData(result[i], doNotLoadBetoniAttr, token);
      }
      return this;
    } catch (err) {
      console.log(err);
    }
    return this;
  };
  processApiData = async (betoni, doNotLoadBetoniAttr, token) => {
    this.keikkaBetoniId = betoni.keikkaBetoniId;
    this.keikkaId = betoni.keikkaId;
    this.m3 = betoni.m3;
    this.isNopea = betoni.isNopea;
    this.betoniComment = betoni.betoniComment;
    this.orderNo = betoni.orderNo;
    this.betoniVahvistettu = betoni.betoniVahvistettu;
    this.laatu.set(betoni);
    this.raeKoko.set(betoni);
    this.lujuus.set(betoni);
    this.notkeus.set(betoni);
    this.kayttoIka.set(betoni);
    this.toimitus.m3 = betoni.toimitettuM3;
    this.hinta_muistiinpanot = betoni.hinta_muistiinpanot;
    this.hinta_value = betoni.hinta_value;
    if (betoni.rasitusluokat != null) {
      this.rasitus.rasitusluokat = betoni.rasitusluokat.split(",");
      this.rasitus.rasitusluokat.sort();
    }
    this.originalHash = this.betoniHash;
    if (!doNotLoadBetoniAttr) {
      // if doNotLoadBetoniAttr then faster loading
      const fullUrl =
        import.meta.env.VITE_SERVER_URL + "/api/keikka/betoni/attr/get/" + this.keikkaBetoniId;
      const c = cache_read(keikkaBetoni_cacheName, fullUrl);
      if (c) {
        this.attr.attr = c.map((_betoniLisa) => {
          let bac = new betoniAttrDataClass();
          bac.attrId = _betoniLisa.attrId;
          bac.keikkaId = _betoniLisa.keikkaId;
          bac.keikkaBetoniId = _betoniLisa.keikkaBetoniId;
          bac.keikkaBetoniAttrId = _betoniLisa.keikkaBetoniAttrId;
          bac.attrNimike = _betoniLisa.attrNimike;
          bac.attrSelite = _betoniLisa.attrSelite;
          bac.attrHelpId = _betoniLisa.attrHelpId;
          bac.keikkaBetoniAttrComment = _betoniLisa.keikkaBetoniAttrComment;
          return bac;
        });
        return this;
      }

      const response = await fetch(fullUrl, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "betoniClass.js:loadApiData");
      if (!cResponse.success) return false;
      const result = cResponse.data;
      cache_write(keikkaBetoni_cacheName, fullUrl, result, 0);
      result &&
        (this.attr.attr = result.map((_betoniLisa) => {
          let bac = new betoniAttrDataClass();
          bac.attrId = _betoniLisa.attrId;
          bac.keikkaId = _betoniLisa.keikkaId;
          bac.keikkaBetoniId = _betoniLisa.keikkaBetoniId;
          bac.keikkaBetoniAttrId = _betoniLisa.keikkaBetoniAttrId;
          bac.attrNimike = _betoniLisa.attrNimike;
          bac.attrSelite = _betoniLisa.attrSelite;
          bac.attrHelpId = _betoniLisa.attrHelpId;
          bac.keikkaBetoniAttrComment = _betoniLisa.keikkaBetoniAttrComment;
          return bac;
        }));
    }
    return this;
  };

  get isKesken() {
    return this.laatu.laatuId === 0;
  }
  get isNothingSelected() {
    if (this.laatu.laatuId > 0) return false;
    if (this.lujuus.lujuusId > 0) return false;
    if (this.notkeus.notkeusId > 0) return false;
    if (this.rasitus.rasitusluokat.length > 0) return false;
    if (this.attr.attr.length > 0) return false;
    if (this.raeKoko.raeKokoId > 0) return false;
    return true;
  }
  nopeaString(getShortString) {
    if (getShortString) {
      return this.isNopea ? "Nopea" : "Norm";
    } else {
      return this.isNopea ? "Nopeasti kovettuva" : "Normaalisti kovettuva";
    }
  }

  get betoniString() {
    return betoni_getString(this);
  }

  get betoniStringNoXC() {
    var a =
      this.laatu.nimike +
      (this.isNopea ? " nopea " : " ") +
      this.raeKoko.raeKokoString +
      " " +
      this.lujuus.lujuusString +
      " " +
      this.notkeus.notkeusString +
      " " +
      this.kayttoIka.kayttoIkaString;
    a = removeEiTietoaFromBetoniString(a);
    return a;
  }
  get betoniIsModified() {
    return this.betoniHash !== this.originalHash;
  }
  // TODO linjaa voi muuttaa kunnes toimitus tapahtuu: (allowEditLinja)
  // auth.originalEdit === true  ?????
  // samalla mahdollistaa m3 ja muiden muutosten toiveiden lähetyksen
  // eli stage2
  betoniError(allowEdit) {
    if (this.keikkaBetoniId === 0) return "Betonissa on virhe (id=0)";
    if (this.maaraError(allowEdit)) return this.maaraError(allowEdit);
    if (this.laatuError(allowEdit)) return this.laatuError(allowEdit);
    if (this.rasitusError(allowEdit)) return this.rasitusError(allowEdit);
    return null;
  }
  maaraError(allowEdit = true) {
    if (this.m3 == 0 || this.m3 == null) {
      if (!allowEdit) return "Betonin määrä puuttuu (m3)";
      else return "Valitse betoni määrä (m3)";
    } else return null;
  }
  laatuError(allowEdit = true) {
    if (this.laatu.laatuId === 0)
      if (!allowEdit) return "Betonin laatua ei valittu";
      else return "Valitse betonin laatu";
    if (this.notkeus.notkeusId === 0)
      if (!allowEdit) return "Betonin notkeutta ei valittu";
      else return "Valitse betonin notkeus";
    if (this.lujuus.lujuusId === 0)
      if (!allowEdit) return "Betonin lujuusta ei valittu";
      else return "Valitse betonin lujuus";
    if (this.raeKoko.raeKokoId === 0)
      if (!allowEdit) return "Betonin raekokoa ei valittu";
      else return "Valitse betonin raekoko";
    if (this.kayttoIka.kayttoIkaId === 0)
      if (!allowEdit) return "Betonin käyttöikää ei valittu";
      else return "Valitse betonin käyttöikä";
    return null;
  }
  rasitusError(allowEdit = true) {
    let errorMsg = allowEdit ? "Valitse rasitusluokat" : "Rasitusluokkia ei valittu";
    if (this.rasitus.rasitusluokat.length === 0) return errorMsg;
    if (this.rasitus.rasitusluokat.length == 1 && this.rasitus.rasitusluokat[0] == "")
      return errorMsg;

    return null;
  }

  get commonHash() {
    const _rasitusHash = this.rasitus.hash; // keikkaBetoni_rasitus_hash(this);
    const _slidersHash = betoniHash_sliders(this);
    const _commentHash = hashCode(this.betoniComment); //keikkaBetoni_comment_hash(this);
    const _attrHash = keikkaBetoni_hash_attr(this);
    return _rasitusHash + _slidersHash + _commentHash + _attrHash;
  }
  get betoniHash() {
    const _m3Hash = this.m3 * 2; //keikkaBetoni_m3_hash(this);
    return this.commonHash + _m3Hash * 17;
  }
  get betoniUniqueHash() {
    const h1 = this.orderNo + 1;
    const h2 = this.keikkaBetoniId;
    const hash = h1 * h2;
    return hash;
  }
}

function removeEiTietoaFromBetoniString(betoniString) {
  return betoniString.replaceAll("Ei tietoa", "").replaceAll("ei tietoa", "").trim();
}

export function keikkaBetoni_hash_m3(betoni) {
  return betoni.m3 * 2;
}

export function keikkaBetoni_hash_comment(betoni) {
  return hashCode(betoni.betoniComment);
}

export function keikkaBetoni_hash_rasitus(betoni) {
  return betoni.rasitus.hash;
}

export function keikkaBetoni_hash_attr(betoni) {
  if (betoni.attr.attr.length === 0) return 0;
  let hash = 0;
  for (let i = 0; i < betoni.attr.attr.length; i++) {
    hash += betoni.attr.attr[i].attrId * 61;
    if (betoni.attr.attr[i].keikkaBetoniAttrComment != null)
      hash += hashCode(betoni.attr.attr[i].keikkaBetoniAttrComment);
  }
  return hash;
}

export function betoniHash_sliders(betoni) {
  if (!betoni) return 0;
  const nopea = Boolean(betoni.isNopea);
  const laatu = betoni.laatu.laatuId;
  const raeKoko = betoni.raeKoko.raeKokoId;
  const lujuus = betoni.lujuus.lujuusId;
  const notkeus = betoni.notkeus.notkeusId;
  const kayttoIka = betoni.kayttoIka.kayttoIkaId;
  return nopea * 13 + laatu * 11 + raeKoko * 7 + lujuus * 5 + notkeus * 3 + kayttoIka * 2;
}
